import { createContext, useContext, useCallback, useState } from 'react'

const ToastContext = createContext(null)
let counter = 0

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const dismiss = useCallback((id) => setToasts((t) => t.filter((x) => x.id !== id)), [])

  // toast(message, variant, ms, action?) — action = { label, onClick } renders a button.
  const toast = useCallback((message, variant = 'default', ms = 2600, action = null) => {
    const id = ++counter
    setToasts((t) => [...t, { id, message, variant, action }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), ms)
    return id
  }, [])

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div className="toast-wrap">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.variant}`}>
            <span>{t.message}</span>
            {t.action && (
              <button
                className="toast-action"
                onClick={() => { t.action.onClick(); dismiss(t.id) }}
              >
                {t.action.label}
              </button>
            )}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  )
}

export const useToast = () => useContext(ToastContext)
